import type { Domain } from '@shared/types/project.type';

export const ACCOUNT_DOMAIN_STORAGE_KEY = 'accountDomain';

/** Maps account/sign-up domain strings (often lowercase) to project `Domain` values. */
const ACCOUNT_DOMAIN_TO_PROJECT: Record<string, Domain> = {
  banking: 'Banking',
  insurance: 'Insurance',
  healthcare: 'Healthcare',
  lifesciences: 'LifeSciences',
  manufacturing: 'Manufacturing',
  pharma: 'Pharma',
  cpg: 'CPG',
  Banking: 'Banking',
  Insurance: 'Insurance',
  Healthcare: 'Healthcare',
  LifeSciences: 'LifeSciences',
  Manufacturing: 'Manufacturing',
  Pharma: 'Pharma',
  CPG: 'CPG'
};

export function normalizeAccountDomainToProjectDomain(raw: string | null | undefined): Domain | null {
  if (!raw || !String(raw).trim()) return null;
  const key = String(raw).trim();
  const direct = ACCOUNT_DOMAIN_TO_PROJECT[key];
  if (direct) return direct;
  const lower = key.toLowerCase();
  return ACCOUNT_DOMAIN_TO_PROJECT[lower] ?? null;
}

export function setAccountDomain(domain: string): void {
  const normalized = normalizeAccountDomainToProjectDomain(domain);
  if (normalized) {
    localStorage.setItem(ACCOUNT_DOMAIN_STORAGE_KEY, normalized);
  } else {
    localStorage.setItem(ACCOUNT_DOMAIN_STORAGE_KEY, domain.trim());
  }
}

/** Domain from account creation / login, used for projects and uploads when not set on the project. */
export function getAccountDomain(): Domain | null {
  return normalizeAccountDomainToProjectDomain(localStorage.getItem(ACCOUNT_DOMAIN_STORAGE_KEY));
}

export function clearAccountDomain(): void {
  localStorage.removeItem(ACCOUNT_DOMAIN_STORAGE_KEY);
}

/** Project domain if set, otherwise the signed-in account domain. */
export function resolveUploadDomain(projectDomain?: string | null): Domain | null {
  return normalizeAccountDomainToProjectDomain(projectDomain) ?? getAccountDomain();
}
